var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"drag-wrap",class:{ 'is-dragging': _vm.isDragging },style:(_vm.wrapStyle),on:{"mousedown":_vm.handleMouseDown}},[_c('div',{staticClass:"drag-wrap__content"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }